<template>
  <div id="components-layout-demo-basic">
    <a-layout>
      <header-view @showLogin="showLogin($event)" :userAcount="userAcount" />
      <a-layout-content class="page-content">
        <router-view></router-view>
      </a-layout-content>
      <!-- <Footer-view /> -->
    </a-layout>
    <div class="shade" v-show="showShades"></div>
    <div class="input-box" v-if="showFlag==1">
      <div class="input-title longer">
        <span href="javascript:;">账号密码登录</span>
        <img src="@img/close.png" @click="closeFlag" alt />
      </div>
      <div class="user-name longer">
        <div class="components-input-demo-presuffix">
          <p class="namestip">帐号</p>
          <a-input placeholder="请输入账号/用户名" v-model="userName" class="input-boxs" ref="userNameInput">
          </a-input>
        </div>
      </div>
      <div class="password longer">
        <div class="components-input-demo-presuffix">
          <p class="namestip">密码</p>
          <a-input
            placeholder="请输入密码"
            v-model="password"
            class="input-boxs"
            ref="passwordInput"
            type="password"
          >
          </a-input>
        </div>
      </div>
      <!-- <div class="remberPass longer">
        <a-checkbox @change="onChange">记住密码</a-checkbox>
      </div> -->
      
      <div class="submit longer">
        <a-button block type="primary" style="height:44px;background: #4CBBFB;" @click="login">登录</a-button>
      </div>
      <div class="another-choice longer">
        <a href="javascript:;" @click="showforget">忘记密码</a>
        <div>
          没有账号？
          <a href="javascript:;" @click="showregister">立即注册</a>
        </div>
      </div>
    </div>
    <div class="register-box" v-if="showReg">
      <div class="input-title longer">
        <span>注册</span>
        <img src="@img/close.png" @click="closeRegister" alt />
      </div>
      <div class="input">
        <a-input placeholder="请输入手机号" v-model="regName"  class="input-boxs" ref="regNameInput">
        </a-input>
      </div>
      <div class="input code">
        <div class="code-input">
          <a-input placeholder="请输入验证码" v-model="regCode" class="input-boxs" ref="regCodeInput">
          </a-input>
        </div>
        <div class="code-btn">
          <a-button
            class="btn"
            type="primary"
            :disabled="resCodeFlag"
            @click="getResCode"
          >{{resCodeText}}</a-button>
        </div>
      </div>
      <div class="input">
        <a-input placeholder="请输入密码" v-model="regpwd" class="input-boxs" ref="regpwdInput" type="password">
        </a-input>
      </div>
      <div class="input submit">
        <a-button type="primary" @click="toRegister">注册</a-button>
        <a-button @click="closeRegister">返回登录</a-button>
      </div>
    </div>
    <div class="forget-box" v-if="showFor">
      <div class="input-title longer">
        <span>修改密码</span>
        <img src="@img/close.png" @click="closeForget" alt />
      </div>
      <div class="input">
        <a-input placeholder="请输入手机号" v-model="forName"  class="input-boxs" ref="forNameInput">
        </a-input>
      </div>
      <div class="input code">
        <div class="code-input">
          <a-input placeholder="请输入验证码" v-model="forCode"  class="input-boxs" ref="forCodeInput">
          </a-input>
        </div>
        <div class="code-btn">
          <a-button class="btn" type="primary" :disabled="codeFlag" @click="getForCode">{{codeText}}</a-button>
        </div>
      </div>
      <div class="input">
        <a-input placeholder="请输入新密码" v-model="forpwd"  class="input-boxs" ref="forpwdInput" type="password">
        </a-input>
      </div>
      <div class="input">
        <a-input placeholder="请再次输入新密码" v-model="forpwdTwo"  class="input-boxs" ref="forpwdTwoInput" type="password">
        </a-input>
      </div>
      <div class="input submit">
        <a-button type="primary" @click="toForget">确认修改</a-button>
        <a-button @click="closeForget">返回登录</a-button>
      </div>
    </div>
    <a-alert :message="errmsg" v-if="errshow" class="errshow" type="error" showIcon />
    <a-alert :message="sucmsg" v-if="sucshow" type="success" class="errshow" showIcon />
    <div class="shades" v-show="firstChose" @click="showfalss"></div>
  </div>
</template>
<script>
import HeaderView from "./components/Header.vue";
// import FooterView from "./components/Footer.vue";
import Cookies from "js-cookie";
import { setTimeout, clearTimeout, setInterval, clearInterval } from "timers";
import { getCookie, group_sign } from '../../utils/tool'
import { params } from '@/config'
export default {
  name: "page",
  components: {
    HeaderView,
    // FooterView
  },
  data() {
    return {
      merchant_id: params.merchant_id,
      passShow: true,
      banner: [
        { id: 0, url: require("@img/banner1.jpg") },
        { id: 1, url: require("@img/banner2.jpg") },
        { id: 2, url: require("@img/banner3.jpg") }
      ],
      userName: "",
      telphone: "",
      password: "",
      regName: "",
      sucshow: false,
      sucmsg: "",
      regCode: "",
      regpwd: "",
      regpwdTwo: "",
      forName: "",
      forCode: "",
      forpwd: "",
      forpwdTwo: "",
      showFlag: 0,
      userAcount: "",
      showShades: false,
      showReg: false,
      codeText: "获取验证码",
      resCodeFlag: false,
      resCodeText: "获取验证码",
      errmsg: "00",
      errshow: false,
      codeFlag: false,
      showFor: false,
      topttile: '',
      topid: '',
      firstChose: false
    };
  },
  created() {
    this.$root.Bus.$on('showLogin', () => {
      this.showLogin()
    })
    if(getCookie('userName') != undefined && getCookie('password') != undefined && this.passShow == true){
      this.userName = getCookie('userName');
      this.password = getCookie('password');
    }
  },
  methods: {
    showfalss() {
      this.firstChose = false
    },
    handleChange(item) {
      this.topttile = item.title;
      this.topid = item.id
    },
    logOuts() {
      if (!this.topid) {
        this.firstChose = false
      this.$router.go(0);
      } else {
        var Days = 30;
        var exp = new Date();
        exp.setTime(exp.getTime() + Days * 24 * 60 * 60 * 1000);
        // document.cookie = "top_category_id=" + this.topid + ";expires=" + exp.toGMTString()
        // document.cookie = `top_category_id=${this.topid}`
      }
      this.topCateGoryTitle = this.topttile;
      this.firstChose = false
      this.$router.go(0);
    },
    onChange(e) {
      if (e.target.checked == true) {
        var Days = 30;
        var exp = new Date();
        exp.setTime(exp.getTime() + Days * 24 * 60 * 60 * 1000);
        // document.cookie = "userName=" + this.userName + ";expires=" + exp.toGMTString()
        // document.cookie = "password=" + this.password + ";expires=" + exp.toGMTString()
        // document.cookie = `userName=${this.userName}`
        // document.cookie = `password=${this.password}`
      }
      // console.log(`checked = ${e.target.checked}`);
    },
    showRand() {
      this.passShow = !this.passShow
    },
    account() {
      this.$refs.userNameInput.focus();
      this.userName = "";
    },
    accounts() {
      this.$refs.telphoneInput.focus();
      this.telphone = "";
    },
    serect() {
      this.$refs.passwordInput.focus();
      this.password = "";
    },
    showLogin(e) {
      this.showFlag = 1;
      this.showShades = true;
      if(e == 0) {
        this.passShow = true
      } else {
        this.passShow = false
      }
    },
    closeFlag() {
      this.showFlag = 0;
      this.showShades = false;
    },
    closeRegister() {
      this.showReg = false;
      this.showFlag = 1;
      this.regName = "";
      this.regCode = "";
      this.regpwd = "";
      this.regpwdTwo = "";
    },
    closeForget() {
      this.showFor = false;
      this.showFlag = 1;
      this.forName = "";
      this.forCode = "";
      this.forpwd = "";
      this.forpwdTwo = "";
    },
    login() {
      let that = this;
      this.userAcount = this.userName;
      var param = group_sign({user_name: that.userName, 
      password: that.password});
      this.$axios.post(this.$Api.apiLogin, param).then(
        res => {
          if (res.data.errcode == 0) {
            let check_token = res.data.result.token;
            let userID = res.data.result.userInfo.id;
            var exps = new Date();
            exps.setTime(exps.getTime() + 8 * 60 * 60 * 1000);
            document.cookie = `userAcount=${that.userName};expires=${exps.toGMTString()};path=/`
            document.cookie = `studentId=${userID};expires=${exps.toGMTString()};path=/`
            document.cookie = `token=${check_token};expires=${exps.toGMTString()};path=/`
            that.showFlag = 0;
            this.showShades = false;
            this.$store.commit("setState", { key: "isLogin", value: true });
            window.location.reload();
          } else {
            this.$message.error(res.data.errmsg)
          }
        }
      )
    },

    showforget() {
      this.showFlag = 0;
      this.showFor = true;
    },
    showregister() {
      this.showFlag = 0;
      this.showReg = true;
    },
    // 获取验证码
    getResCode() {
      let that = this;
      let regName = this.regName;
      var param = group_sign({user_name: regName});
      if (that.resCodeFlag == false) {
        this.$axios.post(this.$Api.apiGetsms, param).then(
          success => {
            let res = success.data
            if (res.errcode == -1) {
                that.$message.error(res.errmsg)
              } else if (res.errcode == 0) {
                that.resCodeFlag = true;
                let s = 59;
                that.resCodeText = s + "s后再次获取";
                let timeRes = setInterval(() => {
                  s = s - 1;
                  that.resCodeText = s + "s后再次获取";
                  if (s == 0) {
                    that.resCodeText = "获取验证码";
                    clearInterval(timeRes);
                    that.resCodeFlag = false;
                  }
                }, 1000);
                timeRes();
              }
          }
        )
      }
    },
    getForCode() {
      let that = this;
      let forName = this.forName;
      var param = group_sign({user_name: forName});
      if (that.codeFlag == false) {
        this.$axios.post(this.$Api.apiForgetGetSms, param).then(
          success => {
            let res = success.data
            if (res.errcode != 0) {
                that.$message.error(res.errmsg)
              } else if (res.errcode == 0) {
                that.codeFlag = true;
                let s = 59;
                that.codeText = s + "s后再次获取";
                let timeRes = setInterval(() => {
                  s = s - 1;
                  that.codeText = s + "s后再次获取";
                  if (s == 0) {
                    that.codeText = "获取验证码";
                    clearInterval(timeRes);
                    that.codeFlag = false;
                  }
                }, 1000);
                timeRes();
              }
          }
        )
      }
    },
    toRegister() {
      let that = this;
      let regCode = this.regCode,
        regName = this.regName,
        regpwd = this.regpwd
      let param =group_sign({user_name: regName,code: regCode,password:regpwd})
      this.$axios.post(this.$Api.submit,param).then(
        success => {
          let res = success.data
          if (res.errcode == 0) {
            that.$message.success("注册成功")
            that.showReg = false;
            that.showFlag = 1;
            let timeErro = setTimeout(() => {
              that.regCode = '';
              that.regName = '';
              that.regpwd = '';
              clearTimeout(timeErro);
            }, 2000);
          } else {
            that.$message.error(res.errmsg)
          }
        }
      )
    },
    // 忘记密码
    toForget() {
      let that = this;
      let forCode = this.forCode,
        forName = this.forName,
        forpwd = this.forpwd,
        forpwdTwo = this.forpwdTwo;
      if (forpwd && forpwdTwo && forpwd.length > 0 && forpwdTwo.length > 0) {
        if (forpwd == forpwdTwo) {
          let param = group_sign({user_name: forName,rand:forCode,password:forpwd,password_again:forpwdTwo})
          this.$axios.post(this.$Api.fogetPwd,param).then(
            res => {
              if (res.data.errcode == 0) {
                  that.$message.success("修改密码成功")
                  that.showFor = false;
                  that.showFlag = 1;
                  let timeErrw = setTimeout(() => {
                    that.forCode = '';
                    that.forName = '';
                    that.forpwd = '';
                    that.forpwdTwo = '';
                    clearTimeout(timeErrw);
                  }, 2000);
                } else {
                  that.$message.error(res.data.errmsg)
                }
            }
          )
        } else {
          that.$message.error("两次输入密码不一致")
        }
      } else {
        that.$message.error("请输入密码")
      }
    }
  },
  beforeMount() {
    if (!!window.ActiveXObject || "ActiveXObject" in window) {
      // this.errshow = true;
      // this.errmsg = "请使用高版本浏览器或者切换到急速模式以获得正常体验";
      this.$message.error("请使用高版本浏览器或者切换到急速模式以获得正常体验")
    }
    if (Cookies.get("userAcount")) {
      this.userAcount = Cookies.get("userAcount");
    }
  },
  // 在组件销毁时别忘了解除事件绑定
  beforeDestroy() {
    this.$root.Bus.$off('showLogin')
  },
};
</script>
<style lang="less" scoped>
@import url('../../assets/less/common.less');
</style>